export default "__VITE_ASSET__BUW$ULLz__"